import React, { useEffect, useState } from "react";
import {
  ActivityCalendar,
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  NewTable,
  useFormHandler,
  Modal,
  DocumentsList,
} from "../../../../../components";
import { transformFiles } from "../../../../../utils/transformFiles";
import { dateFormator, mapTableRows } from "../../../../../utils";
import UnapaidtimesheetdetailsModel from "./Otherpayment/UnapaidtimesheetdetailsModel";
import { otherpaymentrows } from "../../../../../assets/data/candidatesData";
import ActivitiesModal from "./Otherpayment/ActivitiesModal";
import PayOtherPaymentModal2 from "./Otherpayment/PayOtherPaymentModal2";
import PayOtherPaymentModal from "./Otherpayment/PayOtherPaymentModal";
import OtherpaymentUnapaidtimesheetModel from "./Otherpayment/OtherpaymentUnapaidtimesheetModel";
import { useDispatch, useSelector } from "react-redux";
import common from "../../../../../utils/common";
import { fetchTimesheetsPlacements } from "../../../../../redux/slices/timesheets/timesheetApi";
import { getAllEmpOtherPayments } from "../../../../../redux/slices/payroll/payrollSlice";
import { usePagination } from "../../../../../hooks";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { formatCurrency } from "../../../../../utils/stringUtils";
import { exactUTCDate } from "../../../../../utils/dateFormator";
const Otherpayment = ({ setActiveTab }) => {
  const { getCutoffEndDateWithDayjs, convertLocalFormatMMDDYYYY } = common;
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    error,
    employees,
    empOtherPayemntsSelectTimeSheets,
    loading,
  } = useSelector((state) => state.employee);
  const { empOtherPayments } = useSelector((state) => state.payRoll);
  const isLoading = !!loading;
  const empOtherPaymentsData = empOtherPayments?.data || [];
  const dispatch = useDispatch();
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.empotherpays?.data || 0;
  const [model, setmodel] = useState(false);
  const [isActivitiesModal, setISActivitiesModal] = useState(false);
  const [isPayotherpaymentmodel, setISPayotherpaymentmodel] = useState(false);
  const [isUnapaidtimesheetdetails, setISUnapaidtimesheetdetails] =
    useState(false);
  const [OtherpaymentModel, setOtherpaymentModel] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [viewDocsModal, setViewDocsModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [modalMode, setModalMode] = useState("create");

  const handleEditPayment = (row) => {
    setSelectedPayment(row);
    setModalMode("edit");
    setmodel(true);
  };

  const handleViewDocs = (row) => {
    setSelectedDocuments(transformFiles([row]));
    setViewDocsModal(true);
  };

  const handleEditComment = (row) => {
    setmodel(!model);
  };

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
    }
  };

  const handleAnotherAction = async () => {
    setISPayotherpaymentmodel(!isPayotherpaymentmodel);
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler({
      note: "",
    });
  const otherpaymentColumns = [
    // { key: "PayCycle", label: "Pay Cycle" },
    {
      key: "employeeName",
      label: "Employee Name",
      render: (row) => {
        return (
          <div>{`${row?.employeeId?.firstName || ""}  ${
            row?.employeeId?.lastName || ""
          }`}</div>
        );
      },
    },
    {
      key: "clientName",
      label: "Client Name",
      render: (row) => {
        let clients =
          Array.from(
            new Set(
              row?.timesheetId?.map((ts) => ts.clientId?.businessName) || [],
            ),
          )?.join(" \n") || "";
        return <div>{clients}</div>;
      },
    },
    {
      key: "timeperiod",
      label: "Time Period",
      render: (row) => {
        let timeperiod =
          Array.from(
            new Set(
              row?.timesheetId?.map((ts) => ({
                from: ts?.period?.from,
                to: ts?.period?.to,
              })) || [],
            ),
          ) || "";
        // console.log("timeperiod", timeperiod);
        return (
          <div className="flex flex-col">
            {timeperiod?.map((data, index) => (
              <div
                key={index}
              >{`${exactUTCDate(data.from)} - ${exactUTCDate(data.to)}`}</div>
            ))}
          </div>
        );
      },
    },
    {
      key: "PayDate",
      label: "Pay Date",
      render: (row) => {
        return <div>{convertLocalFormatMMDDYYYY(row?.payDate)}</div>;
      },
    },
    {
      key: "ExchangeAmount",
      label: "Exchange Rate",
      render: (row) => {
        return <div>{row?.exchange?.amt || "-"}</div>;
      },
    },
    {
      key: "TotalAmount",
      label: "TotalAmount",
      render: (row) => {
        return <div>{formatCurrency(row?.amounts?.total)}</div>;
      },
    },
    {
      key: "PaidAmount",
      label: "PaidAmount",
      render: (row) => {
        return <div>{formatCurrency(row?.amounts?.paid)}</div>;
      },
    },
    {
      key: "Pending",
      label: "Pending",
      render: (row) => {
        return <div>{formatCurrency(row?.amounts?.pending)}</div>;
      },
    },
    {
      key: "file",
      label: "Documents",
      render: (row) => (
        <div
          className="flex items-center gap-1 flex-row cursor-pointer"
          onClick={
            transformFiles([row] || []).length > 0
              ? () => handleViewDocs(row)
              : () => {}
          }
        >
          <span className="text-linkblue">
            {transformFiles([row]).length} Docs{" "}
          </span>
        </div>
      ),
    },
    // {
    //   key: "OtherPaymentPaid",
    //   label: "Other Payment Paid",
    //   render: (row) => (
    //     <span
    //       className="text-info cursor-pointer"
    //       onClick={() => handleOtherPaymentPaid(row)}
    //     >
    //       {row.OtherPaymentPaid}
    //     </span>
    //   ),
    // },

    // { key: "ModeofPayment", label: "Mode of Payment" },
    {
      key: "comments",
      label: "Comments",
      render: (row) => (
        <div className="flex items-center gap-2">
          <span className="truncate max-w-[150px]">{row.comments}</span>
          <Button
            type="icon"
            size="sm"
            color="dark"
            variant="text"
            icon="edit_square"
            onClick={() => handleEditPayment(row)}
          />
        </div>
      ),
    },
    // {
    //   key: "OtherPaymentAccumulatedthisCycles",
    //   label: "Other Payment Accumulated this Cycles",
    // },
  ];
  // const otherpaymentColumns = [
  //   { key: "PayCycle", label: "Pay Cycle" },
  //   { key: "PayDate", label: "Pay Date",
  //     render:(row)=>{
  //    return(
  //     <div>{convertLocalFormatMMDDYYYY(row?.payDate)}</div>
  //    )
  //   } },
  //   { key: "Earnings", label: "Earnings" },
  //   { key: "Payment", label: "Payment" },
  //   {
  //     key: "OtherPaymentPaid",
  //     label: "Other Payment Paid",
  //     render: (row) => (
  //       <span
  //         className="text-info cursor-pointer"
  //         onClick={() => handleOtherPaymentPaid(row)}
  //       >
  //         {row.OtherPaymentPaid}
  //       </span>
  //     ),
  //   },

  //   { key: "ModeofPayment", label: "Mode of Payment" },
  //   {
  //     key: "comments",
  //     label: "Other Payment Comments",
  //     render: (row) => (
  //       <div className="flex items-center gap-2">
  //         <span className="truncate max-w-[150px]">
  //           {row.comments}
  //         </span>
  //         <Button
  //           type="icon"
  //           size="sm"
  //           color="dark"
  //           variant="text"
  //           icon="edit_square"
  //           onClick={() => handleEditComment(row)}
  //         />
  //       </div>
  //     ),
  //   },
  //   {
  //     key: "OtherPaymentAccumulatedthisCycles",
  //     label: "Other Payment Accumulated this Cycles",
  //   },
  // ];

  const tablerowData = otherpaymentrows;
  console.log("table data for get", empOtherPaymentsData);
  const mappedRows = mapTableRows(empOtherPaymentsData, otherpaymentColumns);

  const handleOtherPaymentPaid = (row) => {
    setOtherpaymentModel(!OtherpaymentModel);
  };

  const handleShowUnpaid = () => {
    setISUnapaidtimesheetdetails(!isUnapaidtimesheetdetails);
  };
  const handleCallApi = async () => {
    dispatch(getAllEmpOtherPayments());
  };
  useEffect(() => {}, []);
  const fetchDeductionDeatils = async () => {
    const filters = {
      // "type": { "type": "NONE", "value": 1 },
      employeeId: { type: "NONE", value: employeeProfileUiid },
    };

    dispatch(
      totalCountStart({
        collection: "empotherpays",
        coll: "EmpOtherPay",
        tname: "empotherpays",
        filters,
      }),
    );
    dispatch(
      getAllEmpOtherPayments({
        coll: "EmpOtherPay",
        limit,
        page,
        filters,
        ref: "Employee Timesheets",
        incl: ["firstName lastName", "clientId period"],
        sort: {
          addedOn: -1,
        },
      }),
    );
  };
  useEffect(() => {
    fetchDeductionDeatils();
  }, [dispatch, page, limit, model, isPayotherpaymentmodel]);

  const handleCloseModal = () => {
    setmodel(false);
    setSelectedPayment(null);
    setModalMode("create");
  };
  return (
    <div>
      <div className="max-w-9xl grid-cols-3 grid gap-x-2 gap-y-6 mt-4">
        {/* <FormFieldSet
          type="text"
          title="Other Payment Note"
          placeholder=" "
          value={formData.note}
          onChange={(value) => handleChange("note", value)}
          error={errors.note}
        />

        <div>
          <Button title="Save" className="mt-5" onClick={handleSave} />
        </div> */}

        <div className="col-span-3 flex justify-end">
          <Button
            title="Pay Other Payment (Offline)"
            onClick={handleAnotherAction}
            color="black"
          />
        </div>
      </div>
      <div className="mt-4">
        <NewTable
          columns={otherpaymentColumns}
          rows={mappedRows}
          limit={limit}
          page={page}
          onPageChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
          serverPagination={true}
          totalCount={totalCount}
        />
      </div>

      {/* <div className="mt-10">
        <div className="flex items-center justify-between">
          <p>ACTIVITIES</p>
        </div>
        <hr className="border-t border-gray-300 mt-2" />
        <div className="flex justify-center mt-6">
          <Button
            title="Activities"
            color="primary"
            onClick={() => setISActivitiesModal(!isActivitiesModal)}
          />
        </div>
      </div> */}
      <ActivitiesModal
        open={isActivitiesModal}
        onClose={() => setISActivitiesModal(!isActivitiesModal)}
      />
      <OtherpaymentUnapaidtimesheetModel
        open={OtherpaymentModel}
        onClose={() => setOtherpaymentModel(!OtherpaymentModel)}
      />

      <div>
        <PayOtherPaymentModal
          open={isPayotherpaymentmodel}
          onClose={() => setISPayotherpaymentmodel(!isPayotherpaymentmodel)}
          onShowUnpaid={handleShowUnpaid}
          empOtherPayemntsSelectTimeSheets={empOtherPayemntsSelectTimeSheets}
        />
      </div>
      <div>
        {/* <UnapaidtimesheetdetailsModel
          open={isUnapaidtimesheetdetails}
          onClose={() =>
            setISUnapaidtimesheetdetails(!isUnapaidtimesheetdetails)
          }
        /> */}
      </div>
      <div>
        <PayOtherPaymentModal2
          open={model}
          onClose={handleCloseModal}
          setActiveTab={setActiveTab}
          initialData={selectedPayment}
          mode={modalMode}
          employeeProfileUiid={employeeProfileUiid}
        />
        <Modal
          isOpen={viewDocsModal}
          onClose={() => setViewDocsModal(false)}
          title="Document Details"
        >
          <DocumentsList data={selectedDocuments} />
        </Modal>
        <Backdrop isOpen={isLoading}>
          <LogoLoader />
        </Backdrop>
      </div>
    </div>
  );
};

export default Otherpayment;
